export default function({ $auth, redirect }) {
  // Check if the user is not logged in
  if (!$auth.loggedIn) {
    // Redirect to the login page
    redirect('/account/inloggen');
  }
}
